import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const InternalNotesTab = ({ notes, onAddNote, onDeleteNote, currentUser, userRole }) => {
  const [newNote, setNewNote] = useState('');
  const [isAdding, setIsAdding] = useState(false);

  const handleAddNote = () => {
    if (newNote?.trim()) {
      onAddNote(newNote);
      setNewNote('');
      setIsAdding(false);
    }
  };

  const canAddNotes = userRole === 'administrator' || userRole === 'dentist_supplier';

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h2 className="text-lg font-semibold text-foreground">Notes internes</h2>
         
        </div>
        {canAddNotes && !isAdding && (
          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            onClick={() => setIsAdding(true)}
          >
           Ajouter note
          </Button>
        )}
      </div>
      {isAdding && (
        <div className="bg-card border border-border rounded-lg p-4">
          <Input
            label="Nouvelle note interne"
            type="text"
            placeholder="Ajouter une note pour la communication interne"
            value={newNote}
            onChange={(e) => setNewNote(e?.target?.value)}
           
          />
          <div className="flex gap-2 mt-4">
            <Button
              variant="outline"
              onClick={() => {
                setIsAdding(false);
                setNewNote('');
              }}
            >
              Annuler
            </Button>
            <Button
              variant="default"
              iconName="Save"
              iconPosition="left"
              onClick={handleAddNote}
              disabled={!newNote?.trim()}
            >
              Enregistrer
            </Button>
          </div>
        </div>
      )}
      <div className="space-y-4">
        {notes?.map((note) => (
          <div key={note?.id} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-medium">
                  {note?.authorInitials}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">{note?.authorName}</p>
                  <p className="text-xs text-muted-foreground">{note?.authorRole}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground">{note?.timestamp}</span>
                {(note?.authorId === currentUser?.id || userRole === 'administrator') && (
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="Trash2"
                    onClick={() => onDeleteNote(note?.id)}
                  />
                )}
              </div>
            </div>

            <div className="p-3 bg-muted rounded-lg">
              <p className="text-sm text-foreground whitespace-pre-wrap">{note?.content}</p>
            </div>

            {note?.edited && (
              <p className="text-xs text-muted-foreground mt-2 flex items-center gap-1">
                <Icon name="Edit" size={12} />
                Modifié {note?.editedAt}
              </p>
            )}
          </div>
        ))}
      </div>
      {notes?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="FileText" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">Aucune note interne pour le moment</p>
          <p className="text-sm text-muted-foreground mt-2">Ajoutez des notes pour le suivi interne</p>
        </div>
      )}
    </div>
  );
};

export default InternalNotesTab;